import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

function PageContainer({ children, gamePage }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const location = useLocation();
  const hiddenSidebarRoutes = ['/', '/auth/register', '/auth/login', '/auth/verification','/auth/forgot-password'];
  const shouldHideSidebar = hiddenSidebarRoutes.includes(location.pathname);

  useEffect(() => {
    // Check if the URL contains '/:slug/' pattern
    const isDynamicRoute = /\/[^/]+\/(buysell|portfolio|leaderboard|profile|charts|feeds|chatHistory|create-feed|edit-feed|followers)/.test(location.pathname);
    setIsCollapsed(isDynamicRoute);
  }, [location]);

  const isMobileView = document.body.clientWidth <= 768;
  const sideBarWidth = shouldHideSidebar ? "" : isCollapsed ? "md:ml-20" : "md:ml-64";
  const isChartsPath = location.pathname.endsWith("/charts");
  const isTradingFloor = location.pathname === "/trading-floor";

  return (
    <div
      className={`${shouldHideSidebar ? "" : isTradingFloor ? "px-0" : "px-2"} ${
        isChartsPath && isMobileView && "!pt-0"
      } ${gamePage ? "game_page_with_sidebar max-md:!block" : "block"} ${
        isMobileView
          ? ` ${sideBarWidth} bg-white`
          : ` ${sideBarWidth} shadow-md bg-white`
      }`}
    >
      {children}
    </div>
  );
}

export default PageContainer;
